import React, { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { removePartnerService } from 'Services/libre_api';
const useLibrePartner = () => {
    const removePartner = useCallback(async (partnerID) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        return removePartnerService(partnerID, user.id, osType, osVersion, app, appVersion);
    }, []);
    const showStopSharingModal = useCallback((partnerName, titleTextKey, bodyTextKey, onRemoveClick) => {
        store.dispatch({
            type: SHOW_MODAL,
            modalProps: {
                buttonLayout: 'column',
                details: (React.createElement(Stack, null,
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.strong", fontSize: "$bodyBase.strong", testID: "StopSharingModal.title", marginBottom: "$4" }, i18n.t(titleTextKey)),
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default", testID: "StopSharingModal.body" }, i18n.t(bodyTextKey, {
                        partnerName,
                    })))),
                primaryAction: {
                    label: i18n.t('Global.modals.stopSharing.title'),
                    destructive: true,
                    onPress: () => {
                        store.dispatch({
                            type: CLOSE_MODAL,
                        });
                        onRemoveClick();
                    },
                },
                secondaryAction: {
                    label: i18n.t('Global.microcopy.common.cancel'),
                    onPress: () => store.dispatch({
                        type: CLOSE_MODAL,
                    }),
                },
                testID: 'StopSharingModal',
            },
        });
    }, []);
    return { removePartner, showStopSharingModal };
};
export default useLibrePartner;
